export enum ESwitchWidth {
  LONG = 'long',
  SHORT = 'short',
}

export enum ESwitchSize {
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
}
